export default __webpack_public_path__ + "static/media/crimsonlotuspollen.4adcd56e.png";